import { create } from "zustand";
import {
  testStatus,
  testType,
  testType as testTypeHelper,
} from "../utils/testHelper";
import {
  canceleTest,
  finishTest,
  initBiletTest,
  submiAnswer,
} from "../utils/API/biletMethod";
import {
  getTestToken,
  getToken,
  removeToken,
  setTestToken,
  setToken,
} from "../utils/utils";
import { checkAuth } from "../utils/API/authMethods";
import { errorHandeler } from "../utils/API/api-utils";
import moment from "moment";

const testInitState = {
  testType: undefined,
  testTitle: undefined,
  biletId: undefined,
  testStatus: undefined,
  testId: undefined,
  // currentTest: undefined,
  // ЗАчем я это придумал?
  testLoading: false,
  questionList: [],
  userAnswers: [],
};

export const useUserStore = create((set, get) => ({
  isAuth: false,
  user: null,
  requestQueue: [],
  enqueueRequest: (reqFn) => {
    const queue = get().requestQueue;
    set({ requestQueue: [...queue, reqFn] });
  },
  flushQueue: () => {
    const queue = get().requestQueue;
    queue.forEach((fn) => fn());
    set({ requestQueue: [] });
  },
  checkMe: async () => {
    const token = getToken();

    setToken(token);
    return checkAuth().catch((err) => errorHandeler(err));
  },
  login: (user) => {
    set({ user: user.name, isAuth: true });
    setToken(user.JWT);
  },
  logout: () => {
    set({ user: null, isAuth: false });
    removeToken();
  },
}));

export const useAlertStore = create((set, get) => ({
  open: false,
  text: "",
  type: "",
  setAlert: (text, type) => {
    set({ open: true, text, type });
    setTimeout(() => {
      get().closeAlert();
    }, 5000);
  },
  closeAlert: () => {
    set({ open: false, text: "", type: "" });
  },
}));

export const useTestStore = create((set, get) => ({
  testType: null,
  testTitle: null,
  biletId: null,
  testStatus: null,
  testId: null,
  startTime: null,
  endTime: null,
  testLoading: false,
  questionList: [],
  userAnswers: [],
  closeTestPreview: null,
  setBaseData: (type, title, biletId) => {
    set({
      testType: type,
      testTitle: title,
      testStatus: testStatus.prepare,
      biletId: biletId,
    });
  },

  canceleTest: () => {
    set({ testStatus: testStatus.canseled, endTime: moment().unix() });
    // console.log("canceled");
    // console.log(get().biletId || get().themeId, get().testType, get().testId);
    canceleTest(
      get().biletId || get().themeId,
      get().testType.type,
      get().testId,
    );
  },
  finishTest: () => {
    set({ testStatus: testStatus.finish, endTime: moment().unix() });
    // console.log("finish", get().biletId);
    finishTest(
      get().biletId || get().themeId,
      get().testType.type,
      get().testId,
    );
  },

  initTest: async (biletId) => {
    set({ userAnswers: [] });
    const biletType = get().testType.type;
    const testSession = getTestToken();
    const initedTest = await initBiletTest(biletId, biletType, testSession);

    const { data, status } = initedTest;

    set((state) => ({
      // ...data,
      // testStatus: data.testStatus || testStatus.start,
      testStatus: testStatus.start,
      questionList: data.questions,
      testId: data.testId,
      userAnswers: data.userAnswers || [],
      startTime: data.startTime,
    }));
    setTestToken(data.testId);
  },

  initPreview: (questionList, answerList, title, closeTestPreview) => {
    set({
      testType: testTypeHelper.preview,
      testStatus: testStatus.start,
      testTitle: title,
      questionList,
      userAnswers: answerList,
      closeTestPreview,
    });
  },
  handleTestPreview: (testType, testStatus) => {
    set({ testType, testStatus });
  },
  submitAnswer: async (questionId, answerId, testId) => {
    const answer = await submiAnswer(testId, answerId, questionId);
    const testType = get().testType.type;

    if (testType == testTypeHelper.marathon.type) {
      set((state) => {
        state.questionList.push(answer.data.nextQuestion);
        return {
          userAnswers: [
            ...state.userAnswers,
            { ...answer.data, questionId, userAnswer: answerId },
          ],
        };
      });
    } else {
      set((state) => ({
        userAnswers: [
          ...state.userAnswers,
          { ...answer.data, questionId, userAnswer: answerId },
        ],
      }));
    }
    return answer.data;
  },
  resetTest: () => {
    set(testInitState);
  },
  setLoading: () => {
    set({ testLoading: true });
  },
  stopLoading: () => {
    set({ testLoading: false });
  },
}));

export const usePortal = create((set) => ({
  open: false,
  rootElement: null,
  setPortal: (element) => {
    set({ open: true, rootElement: element });
  },
  closePortal: () => {
    set({ open: false });
  },
}));

export const useDialog = create((set) => ({
  open: false,
  title: "Вы уверены что хотите покинуть страницу?",
  text: "Если вы покинете страницу решение теста не будет засчиатно",
  okCallback: undefined,
  canceleCallback: undefined,
  closeDialog: () => {
    set({ open: false });
  },
  setDialog: (title, text, okCallback, canceleCallback) => {
    set({
      open: true,
      title,
      text,
      okCallback,
      canceleCallback,
    });
  },
}));
